import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "leaflet/dist/leaflet.css";
// import { BaklavaVuePlugin } from "@baklavajs/plugin-renderer-vue";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
import "leaflet-control-geocoder/dist/Control.Geocoder.css";

import "leaflet-geosearch/assets/css/leaflet.css";

import vuetify from "./plugins/vuetify";

import "./assets/styles/all.scss";
// Vue.use(BaklavaVuePlugin);

import Header from "@/components/header";

Vue.component("Header", Header);

import "./firebase";
import firebase from "firebase/compat/app";
import VueFirestore from "vue-firestore";

Vue.use(VueFirestore);
Vue.use(firebase);

Object.defineProperty(Vue.prototype, "firebase", {
  get() {
    return this.$root.firebase;
  },
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
